angular.module('impactx.search').controller('SearchListSupplierPreSetCtrl', SearchListSupplierPreSetCtrl);

SearchListSupplierPreSetCtrl.$inject = ['OneTimeDataTransporter', 'AppConfiguration', 'ToolbarService'];

function SearchListSupplierPreSetCtrl(OneTimeDataTransporter, AppConfiguration, ToolbarService) {
    var self = this;
    self.showResultsAsList = AppConfiguration.get('displayAllResultsAsList');
    self.suppliers = OneTimeDataTransporter.getData();
    self.numberOfSuppliers = self.suppliers.length;
    self.trns = OneTimeDataTransporter.getTrns();

    var buttonDefinition = [];
    ToolbarService.setButtons(buttonDefinition);
}